import Button from '@doordash/component-button'

import NavBar from '@doordash/component-navbar'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { STATES_NAME } from '../../../constants'
import * as DA from '../../../typeModules/events'
import { Container, Bottom } from './styles'
import { detectWebviewOs } from '../../../utilities/userAgent'
import t from './strings'
import { Select, TextField } from '@doordash/component-fields'

const os = detectWebviewOs()

type MailingAddressProps = {
  mailingAddress?: {
    street: string
    streetLine2: string
    state: string
    city: string
    postalCode: string
  }
  back: () => void
  onSubmit: () => void
  updateMailingAddress?: (any) => Promise<any>
  submitMailingAddress?: (
    uniqueLink,
    mailingAddress,
    application
  ) => Promise<any>
  track: (
    action: DA.EventActions,
    name: DA.AddressCollectionScreens
  ) => Promise<void>
}

export const MailingAddressForm: React.FC<MailingAddressProps> = ({
  mailingAddress,
  updateMailingAddress,
  onSubmit,
  back,
  track,
}) => {
  React.useEffect(() => {
    track(DA.EventActions.Rendered, DA.AddressCollectionScreens.Form)

    // resetting submitted state when coming to this form
    updateMailingAddress({ isSubmitted: false })
  }, [])

  const defaultMailingAddress = {
    street: '',
    streetLine2: '',
    state: '',
    city: '',
    postalCode: '',
  }
  const [mailingAddressErrors, setMailingAddressErrors] = React.useState(
    defaultMailingAddress
  )

  const handleSubmit = () => {
    track(DA.EventActions.Submit, DA.AddressCollectionScreens.Form)

    // clear errors
    setMailingAddressErrors(defaultMailingAddress)
    // validate data here
    // move onto next screen with confirmation
    onSubmit()
  }
  return (
    <React.Fragment>
      <NavBar isSeparatorVisible={false} onNavigationClick={() => back()} />
      <Container>
        <StackChildren>
          <Text styles={Text.Styles.Bold24}>{t.address.title()}</Text>
          <TextField
            accessibilityDescribedBy={'shippingAddressLineOne'}
            value={mailingAddress.street}
            error={mailingAddressErrors.street}
            onChange={value => updateMailingAddress({ street: value })}
            label={t.address.streetAddress()}
            autoComplete="shipping address-line1"
            autoFocus={true}
          />
          <TextField
            accessibilityDescribedBy={'shippingAddressLineTwo'}
            value={mailingAddress.streetLine2}
            error={mailingAddressErrors.streetLine2}
            description={t.address.optional()}
            onChange={value => updateMailingAddress({ streetLine2: value })}
            label={t.address.street2()}
            autoComplete="shipping address-line2"
          />
          <TextField
            accessibilityDescribedBy={'postalCode'}
            value={mailingAddress.postalCode}
            error={mailingAddressErrors.postalCode}
            onChange={value => updateMailingAddress({ postalCode: value })}
            label={t.address.zipCode()}
            autoComplete="shipping postal-code"
          />
          <TextField
            accessibilityDescribedBy={'city'}
            value={mailingAddress.city}
            error={mailingAddressErrors.city}
            onChange={value => updateMailingAddress({ city: value })}
            label={t.address.city()}
            autoComplete="shipping address-level2"
          />
          <Select
            accessibilityDescribedBy={'state'}
            label={t.address.state()}
            value={mailingAddress.state || ''}
            error={mailingAddressErrors.state}
            disabledValue={t.address.selectState()}
            onChange={value => updateMailingAddress({ state: value })}
            options={STATES_NAME}
            name="state"
            autoComplete="shipping address-level1"
          />
        </StackChildren>
      </Container>
      <Bottom>
        <Button
          isDisabled={
            !mailingAddress.postalCode ||
            !mailingAddress.state ||
            !mailingAddress.city ||
            !mailingAddress.street
          }
          onClick={handleSubmit}
        >
          {t.address.primaryAction()}
        </Button>
      </Bottom>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  mailingAddress: state.mailingAddress,
})

const mapDispatchToProps = {
  updateMailingAddress: actions.updateMailingAddress,
}
export default connect(mapStateToProps, mapDispatchToProps)(MailingAddressForm)
